import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

import lense from '../../assets/images/products/specialOffer/spfOne.webp';
import sunglas from '../../assets/images/products/specialOffer/spfThree.webp';
import eyeglas from '../../assets/images/products/specialOffer/spfTwo.webp';

// Styled components
const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 100px;
  padding: 20px;
  background-color: transparent;
`;

const Card = styled.div`
  flex: 1 1 300px;
  max-width: 320px;
  min-width: 280px;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  background-color: ${props => props.bgColor || '#ffffff'};
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: -20px;
    left: -20px;
    right: -20px;
    bottom: -20px;
    border-radius: 10px;
    background-color: ${props => props.overlayColor || '#e0f7fa'};
    z-index: -1;
  }

  @media (max-width: 768px) {
    flex: 1 1 100%;
    max-width: 100%;
  }
`;

const Heading = styled.h3`
  font-size: 1.5rem;
  font-weight: bold;
  margin: 10px 0;
`;

const Button = styled.button`
  border: none;
  padding: 10px 20px;
  border-radius: 30px;
  background-color: transparent;
  color: #007BFF;
  font-weight: bold;
  cursor: pointer;
  border: 2px solid #007BFF;
  transition: background 0.3s, color 0.3s;

  &:hover {
    background-color: #007BFF;
    color: white;
  }
`;

const DiscountLabel = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: #4caf50;
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
`;

const Cards = () => {
  const navigate = useNavigate();

  const handleShowMoreClick = () => {

    const message = "Sunglasses";



    const key = 'ca_id';
    const value = 2;
    const table = 'getallproduct';
    navigate('/prodList', { state: { message, key, value, table } });
  };

  const handleShowMoreLensesClick = () => {
    const message = "Contact lenses";
    const key = null;
    const value = null;
    const table = 'getalllens';
    navigate('/prodList', { state: { message, key, value, table } });
  };

  const handleShowMoreClickSpec = () => {
    const message = "Eyeglasses";
    const key = 'ca_id';
    const value = 10;
    const table = 'getallproduct';
    navigate('/prodList', { state: { message, key, value, table } });
  };

  return (
    <Container>
      <Card bgColor="#E3F2FD" overlayColor="rgba(227, 242, 253, 0.8)">
        <img
          src={sunglas}
          alt="Phenomena"
          style={{ width: '100%', borderRadius: '8px', marginBottom: '10px' }}
        />
        <Heading>Sun Glasses</Heading>
        <Button onClick={handleShowMoreClick}>Shop now</Button>
      </Card>

      <Card bgColor="#C8E6C9" overlayColor="rgba(200, 230, 201, 0.8)">
        <img
          src={eyeglas}
          alt="Glasses On Sale"
          style={{ width: '100%', borderRadius: '8px', marginBottom: '10px' }}
        />
        <Heading>Eye Glasses</Heading>
        <Button onClick={handleShowMoreClickSpec}>Shop now</Button>
      </Card>

      <Card bgColor="#FFEBEE" overlayColor="rgba(255, 235, 238, 0.8)">
        <img
          src={lense}
          alt="Under $50"
          style={{ width: '100%', borderRadius: '8px', marginBottom: '10px' }}
        />
        <Heading>Lenses</Heading>
        <Button onClick={handleShowMoreLensesClick}>Shop now</Button>
      </Card>
    </Container>
  );
};

export default Cards;
